<ng-container *transloco="let t">
  @if (isActive) {
    <header></header>
    <kendo-drawer-container>
      <kendo-drawer
        #drawer
        [items]="items"
        mode="push"
        [mini]="true"
        [miniWidth]="75"
        [width]="250"
        [(expanded)]="expanded"
        [animation]="false"
        [autoCollapse]="false">
        <ng-template kendoDrawerHeaderTemplate>
          <div id="drawer-header">
            <div class="companyContainer">
              @if (expanded) {
                <span class="companyName">{{(currentEmployee$ | async)?.company?.name}}</span>
              }
            </div>
            <a class="navToggle" (click)="drawer.toggle()">
              <img class="toggleIcon" src="../assets/icons/arrow-icon.svg">
            </a>
          </div>
        </ng-template>
        <ng-template kendoDrawerItemTemplate let-item>
          <div
            class="k-drawer-link k-level-{{ item.level }}"
            [routerLink]="item.path"
            [routerLinkActive]="'active'"
            [routerLinkActiveOptions]="{ exact: false }">
            <img class="navIcons" src="../assets/icons/{{item.iconName}}.svg">
            @if (expanded) {
              <span class="navTitles">
                {{item.text}}
              </span>
            }
          </div>
        </ng-template>
        <ng-template kendoDrawerFooterTemplate>
          <div id="drawer-footer">
            <div class="userSettingsContainer">
              <div class="userSettings"
                [routerLink]="['/profile']"
                [routerLinkActive]="['active']">
                <img class="userIcon" src="../assets/icons/profile-icon.svg">
                @if (expanded) {
                  <div class="userInfo">
                    <span class="userName">{{(currentEmployee$ | async)?.firstName + " " + (currentEmployee$ | async)?.lastName}}</span>
                  </div>
                }
              </div>
            </div>
            <div class="logoutContainer">
              <a (click)="onLogout()" class="logoutLink">
                <img class="logoutIcon" src="../assets/icons/logout-icon.svg">
                @if (expanded) {
                  <span class="logoutText">{{t('logout')}}</span>
                }
              </a>
            </div>
            <footer class="footer">
              @if ((connectionState$ | async)) {
                <div class="connectivityStateOnline">
                  <span>online</span>
                </div>
              } @else {
                <div class="connectivityStateOffline">
                  <span>offline</span>
                </div>
              }
              <div class="version">
                <span>{{version}}</span>
              </div>
              <span class="credentialsText">powered by </span>
              <a href="https://www.gizmo.swiss" target="_blank"><img class="gizmoLogo" src="../assets/images/logo+name_gizmo_hellgrau.svg"></a>
            </footer>
          </div>
        </ng-template>
      </kendo-drawer>
      <!-- Main Column -->
      <kendo-drawer-content class="mainCol">
        <main class="mainContent">
          @if (router.url != '/auth') {
            <router-outlet></router-outlet>
          }
        </main>
      </kendo-drawer-content>
    </kendo-drawer-container>
  }

  @if (router.url === '/auth') {
    <router-outlet></router-outlet>
  }

  <app-notification></app-notification>
  <div kendoDialogContainer></div>
</ng-container>
